<!--
 * @Description: 专家基础库
 * @Author: 钱磊
 * @Date: 2022-07-21 10:18:21
-->
<template>
	<div class="h100 audit">
		<filter-layout @search="doSearch" @reset="doRefresh" hasMore v-if="!routeQuery">
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchForm" label-width="100px" :model="searchObj">
					<el-form-item label="姓名：" prop="sname">
						<el-input :placeholder="'请输入'" clearable v-model="searchObj.sname" size="small"></el-input>
					</el-form-item>
					<el-form-item label="手机号：" prop="phone">
						<el-input :placeholder="'请输入'" clearable v-model="searchObj.phone" size="small"></el-input>
					</el-form-item>
					<el-form-item label="证件类型：" prop="applyBus">
						<el-select v-model="searchObj.cardType" placeholder="请选择证件类型" clearable size="small">
							<el-option v-for="(item, index) in smzjlx" :key="'类型' + index" :label="item.sname" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="证件号码：" prop="applyBus">
						<el-input :placeholder="'请输入'" clearable v-model="searchObj.idCard" size="small"></el-input>
					</el-form-item>
				</el-form>
			</template>
			<template #more>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchForm" label-width="100px" :model="searchObj">
					<el-form-item label="性别：" prop="applyBus">
						<el-select v-model="searchObj.sex" placeholder="请选择性别" clearable size="small">
							<el-option label="女" :value="0"></el-option>
							<el-option label="男" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="启用状态：" prop="applyBus">
						<el-select v-model="searchObj.status" placeholder="请选择启用状态" clearable size="small">
							<el-option label="禁用" :value="0"></el-option>
							<el-option label="启用" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="入库时间：" prop="applyBus">
						<div style="display: flex">
							<el-date-picker
								class="w100"
								v-model="searchObj.startTime"
								type="date"
								placeholder="请选择时间"
								size="small"
								value-format="yyyy-MM-dd"
								:editable="false"
								:clearable="true"
								:picker-options="startDatePicker"
							></el-date-picker>

							<span class="text-center pd5">~</span>

							<el-date-picker
								class="w100"
								v-model="searchObj.endTime"
								type="date"
								placeholder="请选择时间"
								size="small"
								value-format="yyyy-MM-dd 23:59:59"
								:editable="false"
								:clearable="true"
								:picker-options="endDatePicker"
							></el-date-picker>
						</div>
					</el-form-item>
					<el-form-item label="年龄：" prop="applyBus">
						<el-row>
							<el-col :span="11">
								<el-input :placeholder="'请输入'" clearable v-model="searchObj.lAge" size="small"></el-input>
							</el-col>
							<el-col :span="2" class="text-center">~</el-col>
							<el-col :span="11">
								<el-input :placeholder="'请输入'" clearable v-model="searchObj.gAge" size="small"></el-input>
							</el-col>
						</el-row>
					</el-form-item>
					<el-form-item label="完善状态：" prop="applyStatus">
						<el-select v-model="searchObj.applyStatus" placeholder="请选择完善状态" clearable size="small">
							<el-option label="未完善" :value="0"></el-option>
							<el-option label="已完善" :value="1"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>

			<template #content>
				<div class="content-header" v-if="!routeQuery">
					<div class="title">
						总共设置了<span class="blue">{{ searchObj.totalResult }}</span>
						项内容
					</div>
					<div class="btnGroups">
						<el-button size="small" class="btn-blue" icon="el-icon-refresh" type="primary" @click="doRefresh"></el-button>
					</div>
				</div>
				<div class="w-table-layout w-table-page" v-if="!routeQuery">
					<div class="w-table-content" v-show="tableShow">
						<vxe-table
							:data="tableObj.tableData"
							:loading="tableObj.loading"
							:border="tableObj.border"
							:resizable="tableObj.resizable"
							:size="tableObj.size"
							:height="tableObj.height"
							highlight-current-row
							highlight-hover-row
							show-overflow="tooltip"
							v-show="tableShow"
							show-header-overflow="tooltip"
						>
							<vxe-table-column type="seq" title="序号" align="center" width="70"></vxe-table-column>
							<vxe-table-column field="sname" title="姓名" min-width="100" align="center"></vxe-table-column>
							<vxe-table-column field="phone" title="手机号码" align="center" min-width="120"></vxe-table-column>
							<vxe-table-column field="cardName" title="证件类型" min-width="110" align="center"></vxe-table-column>
							<vxe-table-column field="idCard" title="证件号码" align="center" min-width="160"></vxe-table-column>
							<vxe-table-column field="sex" title="性别" min-width="70" align="center">
								<template v-slot="{ row }">
									{{ row.sex ? '男' : '女' }}
								</template>
							</vxe-table-column>
							<vxe-table-column field="age" title="年龄" min-width="70" align="center"></vxe-table-column>
							<vxe-table-column field="createDate" title="申请时间" align="center" min-width="160"></vxe-table-column>
							<vxe-table-column field="applyDate" title="入库时间" align="center" min-width="160"></vxe-table-column>
							<vxe-table-column title="完善状态" align="center" min-width="90">
								<template v-slot="{ row }">
									<span v-if="row.applyStatus === 0" class="color-red">未完善</span>
									<span v-if="row.applyStatus === 1" class="color-blue">已完善</span>
								</template>
							</vxe-table-column>
							<vxe-table-column title="状态" align="center" width="90">
								<template v-slot="{ row }">
									<vxe-switch
										v-model="row.status"
										open-label="启用"
										:open-value="1"
										close-label="关闭"
										:close-value="0"
										@change="handleChange(row)"
									></vxe-switch>
								</template>
							</vxe-table-column>
							<vxe-table-column title="操作" width="90" align="center">
								<template v-slot="{ row }">
									<el-button type="success" size="small" round plain class="table-btn" @click="handleCheck(row)" icon="el-icon-view"
										>查看
									</el-button>
								</template>
							</vxe-table-column>
						</vxe-table>
					</div>
					<div class="w-table-footer">
						<vxe-pager
							size="mini"
							:current-page="searchObj.current"
							:page-size="searchObj.size"
							:total="searchObj.totalResult"
							class="text-center"
							:page-sizes="[10, 20, 50, 100]"
							:layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage', 'FullJump']"
							@page-change="handlePageChange"
						>
						</vxe-pager>
					</div>
				</div>
			</template>
		</filter-layout>
		<div class="add-setting" v-if="routeQuery">
			<expert-detail :expertId="expertId"></expert-detail>
		</div>
		<!-- 弹窗 -->
		<el-dialog
			:visible.sync="dialogObj.visible"
			:width="dialogObj.width"
			:title="dialogObj.title"
			:fullscreen="dialogObj.fullscreen"
			center
			class="add-dialog"
			:close-on-click-modal="false"
		>
			<el-form ref="changeState" :model="changeForm" size="medium" :rules="changeRule" label-width="110px">
				<el-row class="mt20" v-if="changeForm.status == '0'">
					<el-col :span="20" :offset="2">
						<el-form-item label="选择原因：" prop="changeReason">
							<el-select v-model="changeForm.changeReason" placeholder="请选择" clearable size="small">
								<el-option v-for="item in zjtyyy" :key="item.value" :label="item.sname" :value="item.value"> </el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="mt20">
					<el-col :span="20" :offset="2">
						<el-form-item label="备注原因：" prop="remark">
							<el-input size="small" v-model="changeForm.remark" maxlength="20" clearable></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="mt20">
					<el-col :span="20" :offset="2">
						<el-form-item label="上传附件：">
							<new-upload
								ref="enclosure"
								:aid="changeForm.changeId"
								width="350px"
								listType="text"
								tableName="expert_status_change"
								assortment="expert_status_change"
								:acceptType="acceptType"
								:maxNum="1"
							></new-upload>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="pdb10 text-center">
				<el-button size="small" class="btn" @click="dialogObj.visible = false">取 消 </el-button>
				<el-button type="primary" size="small" class="btn btn-blue" @click="submitForm" :loading="dialogObj.btnLoading">确 定 </el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { changeStatus, getBaseExpertList, getDictsByParent } from 'api/modules/expert_gz.js'
import { Snowflake } from 'node-snowflake'
import { mapState } from 'vuex'

import NewUpload from '../application-expert/components/new-upload/newUpload.vue'
import ExpertDetail from '../base-expert/components/expert-detail.vue'

export default {
	components: { ExpertDetail, NewUpload },
	data() {
		return {
			showFilter: true,
			searchObj: {
				sname: '', // 专家名称
				phone: '', //手机号
				idCard: '', //证件号码
				cardType: '', //证件类型
				startTime: '', //开始时间
				endTime: '', //结束时间
				status: '', //状态
				sex: '', //性别
				lAge: '', //开始年龄
				gAge: '', //结束年龄
				current: 1, // 当前页码
				size: 10, // 当前每页条数
				totalResult: 0
			},
			// 表格对象
			tableObj: {
				tableData: [],
				loading: false,
				border: true,
				resizable: true,
				size: 'small',
				height: '100%'
			},
			// 弹窗对象
			dialogObj: {
				visible: false,
				width: '80%',
				title: '选择单位',
				fullscreen: false,
				btnLoading: false
			},
			changeRule: {
				remark: [{ required: true, message: '备注原因不能为空！', trigger: 'blur' }],
				changeReason: [{ required: true, message: '请选择原因！', trigger: 'change' }]
			}, //修改专家状态验证规则
			changeForm: {
				changeReason: '', //变更原因
				remark: '', //备注原因
				userId: '', //专家id
				changeId: '', //附件id
				status: 0, //0禁用 1启用
				type: '1', //1修改基础库专家状态 2修改应用库专家状态 3修改应用库状态 4修改专家接受申请状态
				createUser: '' //操作人
			}, //修改专家状态form表单
			acceptType: ['PDF', 'PNG', 'JPEG', 'JPG'],
			zjtyyy: [], //专家停用原因
			searchToggle: true, //筛选控制
			tableShow: true, //表格显隐控制
			startDatePicker: this.beginDate(),
			endDatePicker: this.processDate(),
			expertId: ''
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('searchObj')) {
				this.searchObj = JSON.parse(this.$getSessionItem('searchObj'))

				// 移除 避免污染
				this.$removeSessionItem('searchObj')
			}
			if (this.$getSessionItem('expertId')) {
				// 移除 避免污染
				this.$removeSessionItem('expertId')
			}
		}
		this.doSearch()
	},
	methods: {
		// 查询评价设置列表
		doSearch(page) {
			if (page) {
				this.searchObj.pageSize = 10
				this.searchObj.currentPage = 1
			}
			let params = Object.assign(this.searchObj)
			this.tableObj.loading = true
			getBaseExpertList(params)
				.then((res) => {
					this.tableObj.loading = false
					this.tableObj.tableData = res.data.records
					this.searchObj.totalResult = parseInt(res.data.total)
				})
				.catch((err) => {
					this.tableObj.loading = false
				})
		},
		//刷新/重置
		doRefresh() {
			this.searchObj.size = 10
			this.searchObj.current = 1
			this.searchObj.sname = ''
			this.searchObj.phone = ''
			this.searchObj.idCard = ''
			this.searchObj.cardType = ''
			this.searchObj.startTime = ''
			this.searchObj.endTime = ''
			this.searchObj.status = ''
			this.searchObj.sex = ''
			this.searchObj.lAge = ''
			this.searchObj.gAge = ''
			this.searchObj.applyStatus = ''
			this.doSearch()
		},
		// // 当启用状态发生变化时
		handleChange(data) {
			data.status = data.status ? 0 : 1
			this.dialogObj.title = data.status ? '停用专家库' : '启用专家库'
			this.dialogObj.width = '600px'
			this.dialogObj.visible = true
			this.$nextTick(() => {
				this.$refs.changeState.resetFields()
			})

			this.changeForm.changeId = Snowflake.nextId()
			this.changeForm.userId = data.id
			this.changeForm.status = data.status ? 0 : 1
			this.changeForm.createUser = this.userInfo.sname
			this.getDictsByReason()
		},

		// 获取专家库用途码表
		getDictsByReason() {
			getDictsByParent({ value: '1012' }).then((res) => {
				this.zjtyyy = res.data
			})
		},
		//弹出框提交按钮
		submitForm() {
			this.dialogObj.btnLoading = true
			let param = Object.assign({}, this.changeForm)
			this.changeLibExpert(param)
		},
		//发送请求改变专家状态
		changeLibExpert(params) {
			this.$refs.changeState.validate((valid) => {
				if (valid) {
					changeStatus(params)
						.then((res) => {
							if (res.operationCode == 1) {
								this.doSearch()
								this.dialogObj.btnLoading = false
								this.dialogObj.visible = false
							} else {
								this.$message.error(res.msg)
								this.dialogObj.btnLoading = false
								this.dialogObj.visible = false
							}
						})
						.then((err) => {
							this.dialogObj.btnLoading = false
							this.dialogObj.visible = false
						})
				} else {
					this.dialogObj.btnLoading = false
				}
			})
		},

		// 开始时间的 pickOption
		beginDate() {
			let that = this
			return {
				disabledDate(time) {
					let endTime = ''
					endTime = new Date(that.searchObj.endDate).getTime() + 86400000
					if (endTime) {
						// eslint-disable-next-line no-undef
						return bmElementTimeOptins.limitDateBefore(time, endTime, false)
					} else {
						return time.getTime() > Date.now()
					}
				}
			}
		},

		// 结束时间的 pickOption
		processDate() {
			let that = this
			return {
				disabledDate(time) {
					let startTime = ''
					startTime = new Date(that.searchObj.startDate).getTime() - 86400000
					if (startTime) {
						let nowTime = Date.now() + 86400000
						// eslint-disable-next-line no-undef
						return bmElementTimeOptins.limitDateInRange(time, startTime, nowTime, false)
					} else {
						return time.getTime() > Date.now()
					}
				}
			}
		},

		// 右侧操作
		handleCheck(row) {
			this.expertId = row.id
			this.$setSessionItem('searchObj', JSON.stringify(this.searchObj))
			this.$setSessionItem('expertId', JSON.stringify(this.expertId))
			this.$router.push({
				name: 'base-expert',
				query: {
					type: 'check'
				}
			})
		},
		// 切换状态
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		// 切换分页
		handlePageChange({ currentPage, pageSize }) {
			this.searchObj.current = currentPage
			this.searchObj.size = pageSize
			this.doSearch()
		}
	},
	computed: {
		routeQuery() {
			return this.$route.query.type
		},
		...mapState('app', { isBack: (state) => state.isBack }),
		...mapState('user', { userInfo: (state) => state.userInfo }),
		...mapState('dict', {
			smzjlx: (state) => state.smzjlx
		})
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		}
	}
}
</script>

<style lang="less" scoped>
.content-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 0;
	.title {
		padding-left: 10px;
		border-left: 4px solid #2671cc;
		font-size: 14px;
		color: #202020;
	}
	.blue {
		font-size: 18px;
		color: #2671cc;
	}
}
.pd5 {
	padding: 0 5px;
}
</style>
